import ValidationInterface from "@/plans/common/validation-interface";
import {
  AUSCallingCategories,
  bizPlusCategories, eduPlusCategories,
  GlobalCallingCategories,
  IndiaCallingCategories,
  JapanCallingCategories,
  proPlusCategories,
  UKCallingCategories,
  USCallingCategories,
  ZoomPhoneCategories,
  ZPCallingPlanCategories,
} from "@/common/persist-cart/categories";
import { computedPbxPlans, PBX_SUB_TYPES } from "@/common/service/computers/plans/pbx";
import { BASE_PLAN_SUB_TYPES } from "@/common/constants";

export default class extends ValidationInterface {
  async requires() {
    return [
      //calling plan require usage base plan, and cycle should match
      this.current(ZPCallingPlanCategories).require(["ZVP", "ZVC"], { billingCycleEqual: true, licenseMatch: false }),
      //different region tollfree, phone number require different region calling plan
      this.current(["ZVT", "ZVD"]).require(USCallingCategories),
      this.current(["ZUT", "ZUD", "ZAT", "ZNT", "ZAD"]).require([...UKCallingCategories, ...AUSCallingCategories]),
      this.current("ZJD").require(JapanCallingCategories),
      this.current(["ZSD", "ZGT"]).require(GlobalCallingCategories),
      this.current("ZIND").require(IndiaCallingCategories),
    ];
  }

  async conflicts() {
    // Return a custom function to implement exclusion logic
    return function getConflictingPlans(cart, planToAdd) {
      if (![...ZoomPhoneCategories, ...bizPlusCategories, ...proPlusCategories, ...eduPlusCategories].includes(planToAdd.category)) {
        return [];
      }

      let conflictPlans = [];

      const plans = cart.getAllPlans();
      //these ZP related plans should has same billing cycle, remove all others if billing cycle different
      const sameCycleSubTypes = [
        PBX_SUB_TYPES.METERED,
        PBX_SUB_TYPES.UNLIMITED,
        PBX_SUB_TYPES.TOLLFREE,
        PBX_SUB_TYPES.PHONE_NUMBER,
        PBX_SUB_TYPES.FEATURE,
        PBX_SUB_TYPES.UNLIMITED_ADDON,
        BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
        BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS,
        BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS,
      ];
      const existDiffCyclePlans = plans.filter((p) => sameCycleSubTypes.includes(p.extra.sub_type) && p.billingCycle !== planToAdd.billingCycle);
      if (sameCycleSubTypes.includes(planToAdd.extra?.sub_type) && existDiffCyclePlans.length) {
        conflictPlans = conflictPlans.concat(existDiffCyclePlans);
      }

      const isCallingPlan = [PBX_SUB_TYPES.METERED, PBX_SUB_TYPES.UNLIMITED].includes(planToAdd.extra?.sub_type);
      if (isCallingPlan) {
        const callingPlans = computedPbxPlans(plans).filter(item => [PBX_SUB_TYPES.METERED, PBX_SUB_TYPES.UNLIMITED].includes(item.extra?.sub_type));
        const tollFreeOrPhoneNumberPlans = computedPbxPlans(plans).filter(item => [PBX_SUB_TYPES.TOLLFREE, PBX_SUB_TYPES.PHONE_NUMBER].includes(item.extra?.sub_type));

        //todo UI restriction
        if (planToAdd.extra?.region === "US") {
          conflictPlans = conflictPlans.concat(callingPlans);
          conflictPlans = conflictPlans.concat(tollFreeOrPhoneNumberPlans.filter(plan => plan.extra?.region !== planToAdd.extra?.region));
        } else if (["AU", "UK"].includes(planToAdd.extra?.region)) {
          // AU,UK calling plans can buy now together
          conflictPlans = conflictPlans.concat(callingPlans.filter(plan => !["AU", "UK"].includes(plan.extra?.region)));
          conflictPlans = conflictPlans.concat(tollFreeOrPhoneNumberPlans.filter(plan => !["AU", "UK"].includes(plan.extra?.region)));
        } else {
          conflictPlans = conflictPlans.concat(callingPlans.filter(plan => plan.extra?.region !== planToAdd.extra?.region));
          conflictPlans = conflictPlans.concat(tollFreeOrPhoneNumberPlans.filter(plan => plan.extra?.region !== planToAdd.extra?.region));
        }
      } else {
        conflictPlans = conflictPlans.concat(cart
          .getPlansByFilter((plan) => {
            //same category can't exist
            return plan.category === planToAdd.category;
          }));
      }

      return conflictPlans;
    };
  }
}

//todo UI restriction zp can't exist with biz plus, pro plus, edu plus now
// export class ZPRelatedPlansUIRestrictionRule extends ValidationInterface {
//   async conflicts() {
//     return [
//       ...this.current(ZoomPhoneCategories.filter(c => !["ZVP", "ZVC"].includes(c))).conflict([...proPlusCategories, ...bizPlusCategories, ...eduPlusCategories])
//     ];
//   }
// }
